import {
  SupportService,
  type FaqResponse,
  type TicketResponse,
} from '@acme/api';
import { ContactCard, defaultSupportContact } from '@acme/domains';
import { FaqAccordion, TicketsTable } from '@acme/features';
import { Button } from 'flowbite-react';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

export const HelpCenterPage = () => {
  const navigate = useNavigate();
  const [tickets, setTickets] = useState<TicketResponse[]>([]);
  const [totalCount, setTotalCount] = useState<number>(0);
  const [faqs, setFaqs] = useState<FaqResponse[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadFaq = async () => {
      try {
        const faqsResponse = await SupportService.getApiV1SupportFaqList();
        if (faqsResponse.data) {
          setFaqs(faqsResponse.data.slice(0, 3));
        }
      } catch (error) {
        console.error('Ошибка загрузки FAQ:', error);
      }
    };

    void loadFaq();
  }, []);

  useEffect(() => {
    const loadTickets = async () => {
      try {
        setLoading(true);

        const ticketsResponse = await SupportService.getApiV1SupportTicketList({
          pageNumber: 1,
          pageSize: 50,
        });

        if (ticketsResponse.data) {
          setTickets(ticketsResponse.data.items || []);
          setTotalCount(ticketsResponse.data.totalCount || 0);
        } else {
          setTickets([]);
          setTotalCount(0);
        }
      } catch (error) {
        console.error('Ошибка загрузки обращений:', error);
        setTickets([]);
        setTotalCount(0);
      } finally {
        setLoading(false);
      }
    };

    void loadTickets();
  }, []);

  const handleRulesClick = () => {
    console.log('Навигация к правилам использования');
  };

  const handleCreateTicket = () => {
    navigate('/help/tickets/create');
  };

  const handleViewAll = () => {
    navigate('/help/tickets');
  };

  const handleViewAllFaq = () => {
    navigate('/help/faq');
  };

  const handleRowClick = (ticketId: string) => {
    navigate(`/help/tickets/${ticketId}`);
  };

  return (
    <div className="flex flex-col gap-6 p-6 max-w-7xl mx-auto">
      <div className="flex flex-col gap-2">
        <h1 className="text-2xl font-semibold text-gray-900">Центр помощи</h1>
      </div>

      <ContactCard
        contact={defaultSupportContact}
        onRulesClick={handleRulesClick}
      />

      {!loading && (
        <>
          <div className="flex flex-col gap-6">
            <div className="flex items-start justify-between">
              <h2 className="text-xl font-semibold text-gray-900">
                Мои обращения
              </h2>
              <div className="flex gap-4 items-center">
                <Button color="primary" onClick={handleCreateTicket}>
                  Создать обращение
                </Button>
                {!!totalCount && (
                  <Button color="alternative" onClick={handleViewAll}>
                    Посмотреть все {totalCount}
                  </Button>
                )}
              </div>
            </div>

            <TicketsTable tickets={tickets} onRowClick={handleRowClick} />
          </div>

          <FaqAccordion faqs={faqs} onViewAll={handleViewAllFaq} />
        </>
      )}
    </div>
  );
};
